{
    "offeringItems": {
        "ingresos": [
            {
                "id": "ING-01",
                "nombre": "Diezmo iglesia",
                "tipo": "ingreso",
                "activo": true,
                "orden": 1,
                "icono": "pi-wallet"
            },
            {
                "id": "ING-02",
                "nombre": "Ofrendas diarias",
                "tipo": "ingreso",
                "activo": true,
                "orden": 2,
                "icono": "pi-calendar"
            },
            {
                "id": "ING-03",
                "nombre": "Ofrendas Escuela Dominical",
                "tipo": "ingreso",
                "activo": true,
                "orden": 3,
                "icono": "pi-book"
            },
            {
                "id": "ING-04",
                "nombre": "Ofrendas (Programa Radial)",
                "tipo": "ingreso",
                "activo": true,
                "orden": 4,
                "icono": "pi-microphone"
            },
            {
                "id": "ING-05",
                "nombre": "Ofrenda Misionera",
                "tipo": "ingreso",
                "activo": true,
                "orden": 5,
                "icono": "pi-globe"
            },
            {
                "id": "ING-06",
                "nombre": "Ofrenda Predicador",
                "tipo": "ingreso",
                "activo": true,
                "orden": 6,
                "icono": "pi-user"
            },
            {
                "id": "ING-07",
                "nombre": "Ofrenda Especial o Pro-Templo",
                "tipo": "ingreso",
                "activo": true,
                "orden": 7,
                "icono": "pi-building"
            },
            {
                "id": "ING-08",
                "nombre": "Ayuda Fondo Nacional/Internacional",
                "tipo": "ingreso",
                "activo": true,
                "orden": 8,
                "icono": "pi-flag"
            }
        ],
        "egresos": [
            {
                "id": "EG-B1-01",
                "nombre": "Alquiler local Iglesia",
                "tipo": "egreso",
                "activo": true,
                "orden": 1,
                "icono": "pi-home"
            },
            {
                "id": "EG-B1-02",
                "nombre": "Pago de luz, agua, gas, teléfono (Iglesia)",
                "tipo": "egreso",
                "activo": true,
                "orden": 2,
                "icono": "pi-bolt"
            },
            {
                "id": "EG-B1-03",
                "nombre": "Pago de impuesto",
                "tipo": "egreso",
                "activo": true,
                "orden": 3,
                "icono": "pi-file"
            },
            {
                "id": "EG-B1-04",
                "nombre": "Mantenimiento y mejoras del templo",
                "tipo": "egreso",
                "activo": true,
                "orden": 4,
                "icono": "pi-wrench"
            },
            {
                "id": "EG-B1-05",
                "nombre": "Gastos de oficina, copias, envíos documentos",
                "tipo": "egreso",
                "activo": true,
                "orden": 5,
                "icono": "pi-print"
            },
            {
                "id": "EG-B1-06",
                "nombre": "Compra de mob, equipos, instrumentos",
                "tipo": "egreso",
                "activo": true,
                "orden": 6,
                "icono": "pi-shopping-cart"
            },
            {
                "id": "EG-B1-07",
                "nombre": "Seguridad social",
                "tipo": "egreso",
                "activo": true,
                "orden": 7,
                "icono": "pi-shield"
            },
            {
                "id": "EG-B1-08",
                "nombre": "Alquiler casa pastoral",
                "tipo": "egreso",
                "activo": true,
                "orden": 8,
                "icono": "pi-home"
            },
            {
                "id": "EG-B1-09",
                "nombre": "Pago luz, agua, gas (Casa Pastoral)",
                "tipo": "egreso",
                "activo": true,
                "orden": 9,
                "icono": "pi-bolt"
            },
            {
                "id": "EG-B1-10",
                "nombre": "Transportes, viáticos",
                "tipo": "egreso",
                "activo": true,
                "orden": 10,
                "icono": "pi-car"
            },
            {
                "id": "EG-B1-11",
                "nombre": "Pago préstamos",
                "tipo": "egreso",
                "activo": true,
                "orden": 11,
                "icono": "pi-money-bill"
            },
            {
                "id": "EG-B1-12",
                "nombre": "Programa radial",
                "tipo": "egreso",
                "activo": true,
                "orden": 12,
                "icono": "pi-microphone"
            },
            {
                "id": "EG-B1-13",
                "nombre": "Sostén del pastor",
                "tipo": "egreso",
                "activo": true,
                "orden": 13,
                "icono": "pi-heart"
            },
            {
                "id": "EG-B1-14",
                "nombre": "Otros (Ayudas, comidas, Escuela Dominical)",
                "tipo": "egreso",
                "activo": true,
                "orden": 14,
                "icono": "pi-list"
            },
            {
                "id": "EG-B1-15",
                "nombre": "Ofrenda al predicador",
                "tipo": "egreso",
                "activo": true,
                "orden": 15,
                "icono": "pi-user"
            },
            {
                "id": "EG-B1-16",
                "nombre": "Impuesto vehículo",
                "tipo": "egreso",
                "activo": true,
                "orden": 16,
                "icono": "pi-file"
            },
            {
                "id": "EG-B1-17",
                "nombre": "Mantenimiento del vehículo",
                "tipo": "egreso",
                "activo": true,
                "orden": 17,
                "icono": "pi-wrench"
            },
            {
                "id": "EG-B1-18",
                "nombre": "Parking",
                "tipo": "egreso",
                "activo": true,
                "orden": 18,
                "icono": "pi-stop-circle"
            },
            {
                "id": "EG-B2-01",
                "nombre": "Diezmos de diezmos y ofrendas",
                "tipo": "egreso",
                "activo": true,
                "orden": 19,
                "icono": "pi-percentage"
            },
            {
                "id": "EG-B2-02",
                "nombre": "Ofrenda Misionera",
                "tipo": "egreso",
                "activo": true,
                "orden": 20,
                "icono": "pi-globe"
            },
            {
                "id": "EG-B2-03",
                "nombre": "Ofrenda Pro-convención",
                "tipo": "egreso",
                "activo": true,
                "orden": 21,
                "icono": "pi-calendar"
            },
            {
                "id": "EG-B2-05",
                "nombre": "Cuota FEREDE",
                "tipo": "egreso",
                "activo": true,
                "orden": 22,
                "icono": "pi-id-card"
            },
            {
                "id": "EG-B2-06",
                "nombre": "Gestor",
                "tipo": "egreso",
                "activo": true,
                "orden": 23,
                "icono": "pi-briefcase"
            },
            {
                "id": "EG-B2-08",
                "nombre": "Otras ofrendas y pagos",
                "tipo": "egreso",
                "activo": true,
                "orden": 24,
                "icono": "pi-ellipsis-h"
            },
            {
                "id": "EG-B2-10",
                "nombre": "Seguro de Vida",
                "tipo": "egreso",
                "activo": true,
                "orden": 25,
                "icono": "pi-heart-fill"
            },
            {
                "id": "EG-B2-11",
                "nombre": "Seguro defunción",
                "tipo": "egreso",
                "activo": true,
                "orden": 26,
                "icono": "pi-ban"
            },
            {
                "id": "EG-B2-12",
                "nombre": "I.R.P.F.",
                "tipo": "egreso",
                "activo": true,
                "orden": 27,
                "icono": "pi-percentage"
            },
            {
                "id": "EG-B2-13",
                "nombre": "Pago Sistema Informe",
                "tipo": "egreso",
                "activo": true,
                "orden": 28,
                "icono": "pi-desktop"
            },
            {
                "id": "EG-B2-14",
                "nombre": "Bethel TV España",
                "tipo": "egreso",
                "activo": true,
                "orden": 29,
                "icono": "pi-video"
            },
            {
                "id": "EG-B2-15",
                "nombre": "Pago Préstamo",
                "tipo": "egreso",
                "activo": true,
                "orden": 30,
                "icono": "pi-money-bill"
            },
            {
                "id": "EG-B2-DP",
                "nombre": "Diezmos del pastor",
                "tipo": "egreso",
                "activo": true,
                "orden": 31,
                "icono": "pi-user-plus"
            }
        ]
    },
    "reportFields": {
        "monthly": [
            {
                "id": "IE-01",
                "nombre": "Miembros bautizados activos",
                "tipo": "number",
                "requerido": true,
                "orden": 1,
                "visible": true
            },
            {
                "id": "IE-02",
                "nombre": "Creyentes bautizados no reconocidos",
                "tipo": "number",
                "requerido": true,
                "orden": 2,
                "visible": true
            },
            {
                "id": "IE-03",
                "nombre": "Nuevos creyentes",
                "tipo": "number",
                "requerido": true,
                "orden": 3,
                "visible": true
            },
            {
                "id": "IE-04",
                "nombre": "Miembros bautizados en Espíritu Santo",
                "tipo": "number",
                "requerido": true,
                "orden": 4,
                "visible": true
            },
            {
                "id": "IE-05",
                "nombre": "Profesiones de fe durante el mes",
                "tipo": "number",
                "requerido": true,
                "orden": 5,
                "visible": true
            },
            {
                "id": "IE-06",
                "nombre": "Promedio asistencia Escuela Dominical",
                "tipo": "number",
                "requerido": true,
                "orden": 6,
                "visible": true
            },
            {
                "id": "OB-01",
                "nombre": "Efectuó culto misionero",
                "tipo": "boolean",
                "requerido": true,
                "orden": 7,
                "visible": true
            },
            {
                "id": "OB-02",
                "nombre": "Efectuó culto Santa Cena",
                "tipo": "boolean",
                "requerido": true,
                "orden": 8,
                "visible": true
            },
            {
                "id": "OB-03",
                "nombre": "Asistió a culto confraternidad",
                "tipo": "boolean",
                "requerido": true,
                "orden": 9,
                "visible": true
            },
            {
                "id": "OB-04",
                "nombre": "Recibió visita del presbítero",
                "tipo": "boolean",
                "requerido": true,
                "orden": 10,
                "visible": true
            },
            {
                "id": "OB-05",
                "nombre": "Efectuó visitas",
                "tipo": "boolean",
                "requerido": true,
                "orden": 11,
                "visible": true
            },
            {
                "id": "OB-06",
                "nombre": "Realizó evangelismo",
                "tipo": "boolean",
                "requerido": true,
                "orden": 12,
                "visible": true
            },
            {
                "id": "OB-07",
                "nombre": "Ha fundado campos blancos",
                "tipo": "boolean",
                "requerido": true,
                "orden": 13,
                "visible": true
            },
            {
                "id": "OB-08",
                "nombre": "Ha formado obreros",
                "tipo": "boolean",
                "requerido": true,
                "orden": 14,
                "visible": true
            },
            {
                "id": "OB-09",
                "nombre": "Efectúa ayuda social",
                "tipo": "boolean",
                "requerido": true,
                "orden": 15,
                "visible": true
            },
            {
                "id": "OB-10",
                "nombre": "Efectuó ayuno",
                "tipo": "boolean",
                "requerido": true,
                "orden": 16,
                "visible": true
            }
        ]
    },
    "countries": [
        {
            "id": "espana",
            "nombre": "España",
            "codigo": "ES",
            "activo": true,
            "orden": 1,
            "numberOfZones": 10
        },
        {
            "id": "francia",
            "nombre": "Francia",
            "codigo": "FR",
            "activo": true,
            "orden": 2,
            "numberOfZones": 1
        },
        {
            "id": "portugal",
            "nombre": "Portugal",
            "codigo": "PT",
            "activo": true,
            "orden": 3,
            "numberOfZones": 1
        },
        {
            "id": "suecia",
            "nombre": "Suecia",
            "codigo": "SE",
            "activo": true,
            "orden": 4,
            "numberOfZones": 1
        },
        {
            "id": "finlandia",
            "nombre": "Finlandia",
            "codigo": "FI",
            "activo": true,
            "orden": 5,
            "numberOfZones": 1
        },
        {
            "id": "dinamarca",
            "nombre": "Dinamarca",
            "codigo": "DK",
            "activo": true,
            "orden": 6,
            "numberOfZones": 1
        },
        {
            "id": "islandia",
            "nombre": "Islandia",
            "codigo": "IS",
            "activo": true,
            "orden": 7,
            "numberOfZones": 1
        },
        {
            "id": "noruega",
            "nombre": "Noruega",
            "codigo": "NO",
            "activo": true,
            "orden": 8,
            "numberOfZones": 1
        }
    ],
    "labels": {
        "app_title": "Panel MMM España",
        "welcome_message": "Bienvenido al Panel Administrativo",
        "currency": "EUR",
        "currency_symbol": "€"
    },
    "settings": {
        "timezone": "Europe/Madrid",
        "dateFormat": "DD/MM/YYYY",
        "language": "es-ES"
    }
}